import { Box, Container, Typography } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
// import Image from "../../public/assets/";
// import Image from "./TygerBgimg.svg";

const ContainerWithLogo = (props) => {
  const { children, showHeader = false } = props;
  console.log("check dddddddddd------", showHeader);
  let screenWitdh = window.innerWidth;
  let screenHeight = window.innerHeight;
  console.log("check height----", screenHeight);
  return (
    <Box
      // maxWidth={false}
      // className="container_Th"
      sx={{
        // height: "100%",
        // maxWidth: "425px",
        // width: "100%",
        margin: "auto",
        maxWidth: `${screenWitdh}px`,
        height: "100vh",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        background: "#e9e9e9",
        position: "relative",
        // backgroundImage: `URL("/assets/TygerBgimg.svg")`,
        background: "no-repeat",
        backgroundColor: "#e9e9e9",
      }}
    >
      {showHeader && (
        <Header
          showBar={true}
          step={1}
          showMenu={false}
          showLogoutBtn={false}
          disabledBackBtn
        />
      )}
      {/* <Box
        sx={{
          width: "100%",
          height: 70,
          bgcolor: "#29417c",
          position: "absolute",
          borderRadius: "40%",
          top: "63%",
        }}
      ></Box> */}
      {!showHeader && (
        <Box
        // sx={{
        //   position: "absolute",
        //   top: "12%",
        //   bgcolor: "white",
        //   borderRadius: 3,
        //   // boxShadow: 3,
        //   zIndex: 1,
        //   boxShadow: "inset 0 0 10px #585858",
        // }}
        >
          <img
            src="/assets/TygerBgimg.svg"
            alt="logo"
            style={{
              width: "100%",
              // height: "80px",
              // margin: "10px",
              // marginTop: "16px",
            }}
          />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default ContainerWithLogo;
